import React from 'react';
import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  prefix?: string;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, prefix, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={prefix ? `${prefix}-tabpanel-${index}` : undefined}
      aria-labelledby={prefix ? `${prefix}-tab-${index}` : undefined}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};
